const dialog = {
  MuiDialog: {
    styleOverrides: {
      root: {},
    },
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        fontSize: '22px',
        fontWeight: 500,
      },
    },
  },
};

export default dialog;
